import { render, staticRenderFns } from "./filesHandling.vue?vue&type=template&id=8ed0b652&scoped=true&"
import script from "./filesHandling.vue?vue&type=script&lang=js&"
export * from "./filesHandling.vue?vue&type=script&lang=js&"
import style0 from "./filesHandling.vue?vue&type=style&index=0&id=8ed0b652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed0b652",
  null
  
)

export default component.exports